<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Admin Settings
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;Unsafe Websites</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-shield-halved me-1" style="color: #c62828;"></i>
                  Globally flagged unsafe websites across all organisations.
               </small>
            </div>
         </div>
      </div>

      <UnsafeWebsites />
   </div>
</template>

<script>
import UnsafeWebsites from '@/components/Admin Controls/UnsafeWebsites.vue';

export default {
   components: { UnsafeWebsites },
}
</script>

<style scoped>
.custom-span-lg { font-size: 24px; line-height: 24px; font-weight: bold; }
.custom-span-no-weight { font-size: 24px; line-height: 24px; font-weight: 250; }
</style>